import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "st-list-item-title"
}
const _hoisted_2 = {
  key: 0,
  class: "st-list-item-text"
}

import { computed } from 'vue';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import Badge from '@/components/elements/Badge';
import ButtonCustom from '@/components/elements/ButtonCustom';


export default /*@__PURE__*/_defineComponent({
  __name: 'StListItem',
  props: {
    itemId: { default: '' },
    clickable: { type: Boolean, default: true },
    selected: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    icon: { default: '' },
    title: { default: '' },
    text: { default: '' },
    buttonText: { default: '' },
    badge: { default: () => ({ text: '' }) }
  },
  emits: ['itemClick', 'buttonClick'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { iconPath, getCustomIconStyle } = useCustomIcon();

const showBadge = computed(() => !!props.badge.text);

const handleItemClick = () => {
  if (props.clickable) {
    emit('itemClick', props.itemId);
  }
};

const handleButtonClick = () => {
  if (props.disabled) return;
  emit('buttonClick', props.itemId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["st-list-item", [
      { 'cursor-pointer': _ctx.clickable },
      { 'selected-item': _ctx.selected },
      { 'item-disabled': _ctx.disabled },
    ]]),
    onClick: handleItemClick
  }, [
    (_ctx.icon)
      ? (_openBlock(), _createElementBlock("em", {
          key: 0,
          class: "custom-icons shrink-0",
          style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)(_ctx.icon)))
        }, null, 4))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createTextVNode()),
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createTextVNode()),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      (_ctx.text)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.text), 1))
        : _createCommentVNode("", true)
    ]),
    _cache[2] || (_cache[2] = _createTextVNode()),
    (showBadge.value)
      ? (_openBlock(), _createBlock(_unref(Badge), {
          key: 2,
          class: _normalizeClass(["ml-auto", { 'bg-badge': showBadge.value }]),
          icon: _ctx.badge.icon,
          text: _ctx.badge.text
        }, null, 8, ["icon", "text", "class"]))
      : _createCommentVNode("", true),
    _cache[3] || (_cache[3] = _createTextVNode()),
    (_ctx.buttonText)
      ? (_openBlock(), _createBlock(_unref(ButtonCustom), {
          key: 3,
          type: "important-custom",
          class: "st-list-item-button",
          text: _ctx.buttonText,
          onClick: handleButtonClick
        }, null, 8, ["text"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})